import { JobTitle } from '@connect-x-app/shared-domain-models';
import { UserUtil } from '@connect-x-app/shared-utils';
import { ReceiverOptions } from '@connect-x-app/shared-view-models';

import { determineSystemMessageReceiver } from './determineSystemMessageReceiver.util';

interface RecipientsCellValue {
  isBold: boolean;
  value: string;
}

const getTranslatedRecipients = (recipients: JobTitle[]) => recipients.map(recipient => UserUtil.getDivision(recipient));

export const getRecipientsCellValue = (
  recipients: JobTitle[] | undefined | null,
  allFunctionsTranslation: string,
): RecipientsCellValue => {
  const receiverOption = determineSystemMessageReceiver(recipients);

  if (!recipients || receiverOption === ReceiverOptions.NO_FUNCTIONS) {
    return { isBold: false, value: '-' };
  }

  if (receiverOption === ReceiverOptions.ALL_FUNCTIONS) {
    return { isBold: true, value: allFunctionsTranslation };
  }

  return { isBold: false, value: getTranslatedRecipients(recipients).join(', ') };
};
